import { default as Table } from "./table";

export default Table;
